// tabConfigStarters.js
// Starter templates for the Admin tab-config editor. One entry per block type
// in capture-tab-schema.json v2, plus a blank full-tab starter. Field names
// and block "type" consts here are copied verbatim from the schema so every
// starter validates and renders on first load.

export const BLOCK_STARTERS = {
  scorecard: {
    id: "scores",
    type: "scorecard",
    title: "Scorecard",
    facilitatorNote: "",
    config: {
      dimensions: [
        {
          id: "dimension-one",
          label: "Dimension One",
          phase: "",
          expectedScore: 3,
          expectedLabel: "",
          facilitatorPrompt: "",
          watchFor: "",
          anchors: { "1": "", "2": "", "3": "", "4": "", "5": "" },
          questions: []
        }
      ],
      scale: { min: 1, max: 5 },
      gateThreshold: 3,
      captureFields: ["note"],
      showSummaryStats: true
    }
  },
  gate_checklist: {
    id: "gate",
    type: "gate_checklist",
    title: "Gate Checklist",
    facilitatorNote: "",
    config: {
      items: [
        { id: "criterion-one", label: "Criterion one", defaultOwner: "" }
      ],
      notesPlaceholder: "Notes or conditions..."
    }
  },
  matrix: {
    id: "matrix",
    type: "matrix",
    title: "Matrix",
    facilitatorNote: "",
    config: {
      rowLabel: "Item",
      rows: [{ id: "row-one", label: "Row One" }],
      columns: [{ id: "col-one", label: "Column One", inputType: "text" }],
      allowAddRows: false
    }
  },
  list: {
    id: "list",
    type: "list",
    title: "List",
    facilitatorNote: "",
    config: {
      itemLabel: "Item",
      items: [{ id: "item-one", label: "Item One" }],
      fields: [{ id: "note", label: "Note", inputType: "text" }]
    }
  },
  narrative: {
    id: "narrative",
    type: "narrative",
    title: "Narrative",
    facilitatorNote: "",
    config: {
      entryLabel: "Entry",
      fields: [{ id: "summary", label: "Summary", inputType: "textarea" }],
      allowMultipleEntries: true
    }
  },
  tracker: {
    id: "tracker",
    type: "tracker",
    title: "Tracker",
    facilitatorNote: "",
    config: {
      itemLabel: "Item",
      items: [{ id: "item-one", label: "Item One" }],
      statusOptions: ["Not started", "In progress", "Done"],
      phaseOptions: []
    }
  },
  decision_log: {
    id: "decisions",
    type: "decision_log",
    title: "Decision Log",
    facilitatorNote: "",
    config: {
      areaLabel: "Area",
      areas: [{ id: "area-one", label: "Area One" }],
      captureFields: ["optionsConsidered", "chosen", "rationale", "owner", "date"]
    }
  },
  commitment_log: {
    id: "commitments",
    type: "commitment_log",
    title: "Commitment Log",
    facilitatorNote: "",
    config: {
      areaLabel: "Area",
      areas: [{ id: "area-one", label: "Area One" }],
      captureFields: ["commitment", "owner", "dueDate", "status"]
    }
  }
};

export const BLOCK_TYPE_LABELS = {
  scorecard: "Scorecard",
  gate_checklist: "Gate Checklist",
  matrix: "Matrix",
  list: "List",
  narrative: "Narrative",
  tracker: "Tracker",
  decision_log: "Decision Log",
  commitment_log: "Commitment Log"
};

export const BLANK_TAB_CONFIG = {
  id: "new-capture-tab",
  name: "New Capture Tab",
  category: "capture",
  description: "",
  storageKey: "newCaptureTab",
  facilitatorGuide: "",
  blocks: [BLOCK_STARTERS.scorecard],
  footer: {
    acknowledgmentKey: "ack",
    acknowledgmentLabel: "Acknowledged",
    notesKey: "notes",
    notesLabel: "Notes",
    notesPlaceholder: "Notes..."
  }
};
